import React from 'react';
import { subscribe } from 'reffects-store';
import { dispatch } from 'reffects';
import Button from '../../../components/library/Button/Button';
import TextInput from '../../../components/library/Input/TextInput/TextInput';
import MessageCard from '../../../components/library/MessageCard/MessageCard';
import '../../../components/LoginLayout/LoginLayout.css';

function formErrorSelector(state) {
  return state.formError;
}

function EmailSentMessage({ visible }) {
  return visible ? (
    <MessageCard>
      {trovitApp.i18n('login_forgotten_password_email_sent')}
    </MessageCard>
  ) : null;
}

function ContinueButton({ alreadySent }) {
  return !alreadySent ? (
    <Button color="thribee-yellow" variant="flat" type="submit">
      {trovitApp.i18n('g_continue')}
    </Button>
  ) : null;
}

function BackToLoginButton({ showAsLink, onShowLoginForm }) {
  return showAsLink ? (
    <a
      className="Login__Link"
      href="/"
      onClick={e => {
        e.preventDefault();
        onShowLoginForm();
      }}
    >
      &larr; {trovitApp.i18n('partners_login')}
    </a>
  ) : (
    <Button
      onClick={() => {
        onShowLoginForm();
      }}
      color="thribee-yellow"
      variant="flat"
      type="button"
    >
      &larr; {trovitApp.i18n('partners_login')}
    </Button>
  );
}

export function ForgotPassword({
  onSubmit,
  isRecoveryRequested = false,
  onShowLoginForm,
}) {
  return (
    <div>
      <h1 className="Login__formTitle">{trovitApp.i18n('forgot_password')}</h1>
      <p className="Login__formSubtitle">
        {trovitApp.i18n('forgotten_password_login_thribee')}
      </p>

      <form className="Login__form" onSubmit={onSubmit}>
        <TextInput
          color="thribee-yellow"
          name="email"
          label="Email"
          type="email"
          required
          disabled={isRecoveryRequested}
        />
        <EmailSentMessage visible={isRecoveryRequested} />
        <ContinueButton alreadySent={isRecoveryRequested} />
        <BackToLoginButton
          showAsLink={!isRecoveryRequested}
          onShowLoginForm={onShowLoginForm}
        />
      </form>
    </div>
  );
}

export default subscribe(
  ForgotPassword,
  function mapStateToProps(state) {
    return {
      formError: formErrorSelector(state),
      isRecoveryRequested: state.disableForgotPasswordForm,
    };
  },
  {
    onSubmit(e) {
      e.preventDefault();
      dispatch({
        id: 'REQUEST_RESET_PASSWORD',
        payload: {
          email: e.target.email.value,
        },
      });
    },
  }
);
